import { Note } from '../models/Note';

function toMillis(dateLike: unknown): number {
    if (dateLike instanceof Date) {
        const time = dateLike.getTime();
        return Number.isNaN(time) ? 0 : time;
    }

    if (typeof dateLike === 'string' || typeof dateLike === 'number') {
        const time = new Date(dateLike).getTime();
        return Number.isNaN(time) ? 0 : time;
    }

    return 0;
}

export function sortNotesNewestFirst<T extends Pick<Note, 'createdAt' | 'updatedAt' | 'id'>>(notes: T[]): T[] {
    return [...notes].sort((a, b) => {
        const createdAtDiff = toMillis(b.createdAt) - toMillis(a.createdAt);
        if (createdAtDiff !== 0) {
            return createdAtDiff;
        }

        const updatedAtDiff = toMillis(b.updatedAt) - toMillis(a.updatedAt);
        if (updatedAtDiff !== 0) {
            return updatedAtDiff;
        }

        return (b.id ?? 0) - (a.id ?? 0);
    });
}
